<template>
  <BaseModal :modalTitle="$t('W: Vælg analyser')">
    <div class="flex max-h-[60vh] flex-col gap-6 overflow-y-auto px-6 pb-2">
      <div
        v-for="group in analysisGroups"
        :key="group.id">
        <p class="mb-2 text-sm font-medium text-text-secondary">
          {{ group.name }}
        </p>
        <UiInputCheckboxGroupVee
          :name="`analysisIDs-${group.id}`"
          :options="group.options"
          :modelValue="localSelectedIDs"
          @update:model-value="localSelectedIDs = $event" />
      </div>

      <p
        v-if="analysisGroups.length === 0"
        class="text-sm text-text-muted">
        {{ $t('area.pricing-segment.message.no-compatible-analyses') }}
      </p>
    </div>

    <template #buttons>
      <UiBaseButton
        :text="$t('action.cancel')"
        theme="neutral"
        @button-click="closeTop" />
      <UiBaseButton
        :text="$t('action.save')"
        @button-click="onConfirmClick" />
    </template>
  </BaseModal>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { useAnalysisStore } from '@/stores/analysisStore'
import { useSampleAreaStore } from '@/stores/sampleAreaStore'
import { useAppStore } from '@/stores/appStore'
import { useModalStore } from '@/stores/modalStore'
import { mapActions, mapState } from 'pinia'
import {
  groupAnalysesBySampleArea,
  type IAnalysisPickerGroup,
} from '@/globals/typescript/utils/analysisPickerGroups'

export default {
  name: 'PricingSegmentAnalysisPickerModal',

  props: {
    selectedAnalysisIDs: {
      type: Array as PropType<string[]>,
      required: true,
    },
    onConfirm: {
      type: Function as PropType<(analysisIDs: string[]) => void>,
      required: true,
    },
  },

  data() {
    return {
      localSelectedIDs: [...this.selectedAnalysisIDs] as string[],
    }
  },

  computed: {
    ...mapState(useAnalysisStore, ['activeAnalyses']),
    ...mapState(useSampleAreaStore, ['allSampleAreas']),
    ...mapState(useAppStore, ['currentLocale']),

    analysisGroups(): IAnalysisPickerGroup[] {
      return groupAnalysesBySampleArea({
        analyses: this.activeAnalyses,
        sampleAreas: this.allSampleAreas,
        locale: this.currentLocale,
        ungroupedLabel: this.$t('W: Uden prøveområde'),
        toOption: (analysis) => ({
          value: analysis.id,
          text: analysis.getName(this.currentLocale),
        }),
      })
    },
  },

  methods: {
    ...mapActions(useModalStore, ['closeTop']),

    onConfirmClick(): void {
      // Close before confirming: `onConfirm` may open a confirmation modal of its own (a removed
      // analysis that carries a deal), and closing afterwards would close THAT one instead — the
      // modal stack is last-in-first-out — leaving this picker open and Gem looking dead.
      this.closeTop()
      this.onConfirm(this.localSelectedIDs)
    },
  },
}
</script>
